import {Component, OnInit, Input} from '@angular/core';
import {CheckBoxOptionsBeanModel} from '../../models/checkbox-options-bean.model';
import {ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';

@Component({
    selector: 'app-questions',
    templateUrl: './questions.page.html',
    styleUrls: ['./questions.page.scss'],
})
export class QuestionsPage implements OnInit {
    @Input() document: DocumentModel;
    radioValue: any;

    checkBoxOptions = new CheckBoxOptionsBeanModel();

    constructor(private modalController: ModalController) {
    }

    ngOnInit() {
        this.checkBoxOptions.option1 = false;
        this.checkBoxOptions.option2 = false;
        this.checkBoxOptions.option3 = false;
        this.checkBoxOptions.option4 = false;
        this.checkBoxOptions.option5 = false;
        this.checkBoxOptions.option6 = false;
    }

    checkOption(event) {
        console.log(event.detail.value);
        if (event.detail.value) {
            switch (event.detail.value) {
                case '1': {
                    this.checkBoxOptions.option1 = true;
                    this.checkBoxOptions.option2 = false;
                    this.checkBoxOptions.option3 = false;
                    break;
                }
                case '2': {
                    this.checkBoxOptions.option1 = false;
                    this.checkBoxOptions.option2 = true;
                    this.checkBoxOptions.option3 = false;
                    break;
                }
                case '3': {
                    this.checkBoxOptions.option1 = false;
                    this.checkBoxOptions.option2 = false;
                    this.checkBoxOptions.option3 = true;
                    break;
                }
                case '4': {
                    this.checkBoxOptions.option4 = true;
                    this.checkBoxOptions.option5 = false;
                    this.checkBoxOptions.option6 = false;
                    break;
                }
                case '5': {
                    this.checkBoxOptions.option4 = false;
                    this.checkBoxOptions.option5 = true;
                    this.checkBoxOptions.option6 = false;
                    break;
                }
                case '6': {
                    this.checkBoxOptions.option4 = false;
                    this.checkBoxOptions.option5 = false;
                    this.checkBoxOptions.option6 = true;
                    break;
                }
                default: {
                    this.checkBoxOptions.option1 = false;
                    this.checkBoxOptions.option2 = false;
                    this.checkBoxOptions.option3 = false;
                    this.checkBoxOptions.option4 = false;
                    this.checkBoxOptions.option5 = false;
                    this.checkBoxOptions.option6 = false;
                    break;
                }
            }
            console.log(this.checkBoxOptions.option1,
                this.checkBoxOptions.option2,
                this.checkBoxOptions.option3,
                this.checkBoxOptions.option4,
                this.checkBoxOptions.option5,
                this.checkBoxOptions.option6);
        }
    }

    saveQuestions() {
        this.document.checkBoxOptionsBean = this.checkBoxOptions;
        this.modalController.dismiss();
    }

    selectColor(value) {
        if ((value === 1 && this.checkBoxOptions.option1)
            || (value === 4 && this.checkBoxOptions.option4)) {
            return 'success';
        } else if ((value === 2 && this.checkBoxOptions.option2)
            || (value === 5 && this.checkBoxOptions.option5)) {
            return 'danger';
        } else if ((value === 3 && this.checkBoxOptions.option3)
            || (value === 6 && this.checkBoxOptions.option6)) {
            return 'warning';
        }
    }
}
